// Lightbox functionality
let currentImageIndex = 0;
let currentLightbox = null;
let currentImages = [];

function openLightbox(img, lightboxId = 'lightbox') {
    const lightbox = document.getElementById(lightboxId);
    const lightboxImg = lightbox.querySelector('.lightbox-img');
    const imageGroup = img.closest('.sample-images, .reviews-grid');
    
    if (imageGroup) {
        currentImages = Array.from(imageGroup.querySelectorAll('img'));
        currentImageIndex = currentImages.indexOf(img);
        currentLightbox = lightbox;
        
        lightboxImg.src = img.src;
        lightboxImg.alt = img.alt;
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
}

function closeLightbox(lightboxId = 'lightbox') {
    const lightbox = document.getElementById(lightboxId);
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
    currentImages = [];
    currentImageIndex = 0;
    currentLightbox = null;
}

function prevImage(lightboxId = 'lightbox') {
    if (currentImages.length > 0) {
        currentImageIndex = (currentImageIndex - 1 + currentImages.length) % currentImages.length;
        const lightboxImg = document.getElementById(lightboxId).querySelector('.lightbox-img');
        lightboxImg.src = currentImages[currentImageIndex].src;
        lightboxImg.alt = currentImages[currentImageIndex].alt;
    }
}

function nextImage(lightboxId = 'lightbox') {
    if (currentImages.length > 0) {
        currentImageIndex = (currentImageIndex + 1) % currentImages.length;
        const lightboxImg = document.getElementById(lightboxId).querySelector('.lightbox-img');
        lightboxImg.src = currentImages[currentImageIndex].src;
        lightboxImg.alt = currentImages[currentImageIndex].alt;
    }
}

// Close lightbox when clicking outside the image
document.addEventListener('click', function(event) {
    const lightboxes = document.querySelectorAll('.lightbox');
    lightboxes.forEach(lightbox => {
        if (event.target === lightbox) {
            closeLightbox(lightbox.id);
        }
    });
});

// Keyboard navigation
document.addEventListener('keydown', function(event) {
    if (currentLightbox && currentLightbox.classList.contains('active')) {
        if (event.key === 'Escape') {
            closeLightbox(currentLightbox.id);
        } else if (event.key === 'ArrowLeft') {
            prevImage(currentLightbox.id);
        } else if (event.key === 'ArrowRight') {
            nextImage(currentLightbox.id);
        }
    }
}); 